import React, { Component } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"

class DatePickerForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fromDate: "",
      toDate: "",
    }
    this.locale = document.documentElement.lang === "da" ? da : enGB
  }

  formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()
    return `${day} / ${month} / ${year}`
  }

  handleFromDateChange = (date) => {
    this.setState({ fromDate: this.formatDate(date) })
  }

  handleToDateChange = (date) => {
    this.setState({ toDate: this.formatDate(date) })
  }

  render() {
    return (
      <div className="form">
        <div className="form__section form__section--light form__section--short booking-form-datepicker">
          <div className={`form__field form__field--date form__field--short booking-date-from ${this.state.fromDate ? "is-filled" : ""}`}>
            <DatePicker
              id={`fromDatePicker-${this.props.sourceTable}`}
              selected={this.state.fromDate ? new Date(this.state.fromDate.split(" / ").reverse().join("-")) : null}
              onChange={this.handleFromDateChange}
              dateFormat="dd / MM / yyyy"
              locale={this.locale}
              className={`form__item ${this.props.sourceTable}--from`}
            />
            <label className="form__label" htmlFor={`fromDatePicker-${this.props.sourceTable}`}>
              <span className="form__label__text">
                {this.props.bookingDatePickerFrom}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>

          <div className={`form__field form__field--date form__field--short booking-date-to ${this.state.toDate ? "is-filled" : ""}`}>
            <DatePicker
              id={`toDatePicker-${this.props.sourceTable}`}
              selected={this.state.toDate ? new Date(this.state.toDate.split(" / ").reverse().join("-")) : null}
              onChange={this.handleToDateChange}
              dateFormat="dd / MM / yyyy"
              locale={this.locale}
              minDate={this.state.fromDate ? new Date(this.state.fromDate.split(" / ").reverse().join("-")) : null}
              className={`form__item ${this.props.sourceTable}--to`}
            />
            <label className="form__label" htmlFor={`toDatePicker-${this.props.sourceTable}`}>
              <span className="form__label__text">
                {this.props.bookingDatePickerTo}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>

          <button
            className="button button--medium button--general booking-form-button"
            onClick={() => this.props.changeDateState(this.state.fromDate, this.state.toDate)}
          >
            <span className="text">{this.props.datepickerButtonText || "Submit"}</span>
          </button>
        </div>
      </div>
    )
  }
}

export default DatePickerForm
